import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

export const SocialButtonsContainer = styled.div`
  ${breakpoint('landscape')`
    display: flex;
    justify-content: flex-start;
  `};
`
